export default __webpack_public_path__ + "static/media/fondo2.c43c744d.png";